import { gql, useQuery } from "@apollo/client";
import { DSP_FIELDS, DspType } from "../../../../../graphql/types/DspType";

const GET_ALL_DSPS_FOR_WMS_PERMISSION = gql`
  query GetAllDspsForWmsPermission($warehouseId: Long!) {
    allDspsForWmsPermission: getAllDspsForWmsPermission(warehouseId: $warehouseId) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

interface GetAllDspsForWmsPermissionResponse {
    allDspsForWmsPermission: DspType[];
}

export const useAllDspsForWmsPermission = (warehouseId?: string | null, skip?: boolean) => {
    const { data, loading, error, refetch } = useQuery<GetAllDspsForWmsPermissionResponse>(
        GET_ALL_DSPS_FOR_WMS_PERMISSION, {
        skip: skip || !warehouseId,
        variables: { warehouseId: warehouseId ? parseInt(warehouseId) : 0 },
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    return {
        allDspsForWmsPermission: data?.allDspsForWmsPermission || [],
        loading,
        error,
        refetch
    };
};
